export default __webpack_public_path__ + "static/favicon-a3c393fb2f166337695cc913380ee6a5.ico";